import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { TicketsystemService } from '../ticketsystem/ticketsystem.service';
import { LoginService } from '../user/login.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
    private snackbarRef: MatSnackBarRef<TextOnlySnackBar>;

    constructor(
        private readonly snackbar: MatSnackBar,
        private readonly ticketsystemService: TicketsystemService,
        private readonly loginService: LoginService,
    ) {}

    infoMessageAction(text: string, action: string): Observable<void> {
        this.close();
        this.snackbarRef = this.snackbar.open(text, action, {
            duration: 8000,
            verticalPosition: 'bottom',
            panelClass: ['snackbar-ok'],
        });
        return this.snackbarRef.onAction();
    }

    private close(): void {
        this.snackbarRef?.dismiss();
        this.snackbarRef = undefined;
    }

    infoMessage(text: string): void {
        this.close();
        const ref = this.snackbar.open(text, 'OK', {
            duration: 4000,
            verticalPosition: 'bottom',
            panelClass: ['snackbar-ok'],
        });
        ref.onAction().subscribe(() => {
            this.close();
        });
        this.snackbarRef = ref;
    }

    alertMessage(text: string) {
        this.close();
        const ref = this.snackbar.open(text, 'OK', {
            duration: 4000,
            verticalPosition: 'bottom',
            panelClass: ['snackbar-alert'],
        });
        ref.onAction().subscribe(() => {
            this.close();
        });
        this.snackbarRef = ref;
    }

    hintMessage(text: string) {
        this.close();
        const ref = this.snackbar.open(text, 'OK', {
            duration: 4000,
            verticalPosition: 'bottom',
            panelClass: ['snackbar-hint'],
        });
        ref.onAction().subscribe(() => {
            this.close();
        });
        this.snackbarRef = ref;
    }

    updateMessage(version: string): void {
        this.snackbar
            .open('Es ist eine neue Version (' + version + ') verfügbar.', 'Jetzt aktualisieren', {
                duration: 10000,
                panelClass: ['snackbar-hint'],
                horizontalPosition: 'start',
                verticalPosition: 'bottom',
            })
            .onAction()
            .subscribe(() => {
                this.loginService.reloadSession().subscribe({
                    next: () => {
                        location.reload();
                    },
                });
            });
    }

    errorMessage(text: string, errorObject: HttpErrorResponse) {
        let fehler = '';
        if (errorObject) {
            if (errorObject.status === 0) {
                text = '';
                fehler = 'Keine Internetverbindung!';
            } else if (errorObject.error) {
                if (errorObject.error.errortext) {
                    fehler = '\n' + errorObject.error.errortext;
                } else if (errorObject.error.fehler) {
                    fehler = '\n' + errorObject.error.fehler;
                } else {
                    if (typeof errorObject.error === 'object') {
                        fehler = '\n' + errorObject.error;
                    } else if (typeof errorObject.error === 'string') {
                        const err = JSON.parse(errorObject.error);
                        fehler = '\n' + err.errortext;
                    } else {
                        fehler = '\n';
                    }
                }
            }
        }
        this.close();
        const ref = this.snackbar.open(text + fehler, 'Melden', {
            duration: 6000,
            verticalPosition: 'bottom',
            panelClass: ['snackbar-alert'],
        });
        ref.onAction().subscribe({
            next: () => {
                this.ticketsystemService.openCreateTicketDialog(errorObject?.url).then();
            },
        });
        this.snackbarRef = ref;
    }
}
